import React from 'react';
import { withBasicDetails } from '../../base/components/WithBasicDetails';
import { routeMappings } from '../../constants';
import { withNoAuthentication } from './WithNoAuthentication';
import { getCookie } from '../../common/utils/cookies';

const tcPlusFlow = getCookie('TcPlusFlag') === '1';
const rootFolder = tcPlusFlow ? 'authSimplified' : 'authentication';
const SocialSignOnConfirm = React.lazy(() => import(`../../${rootFolder}/components/SocialSignOnConfirm`));
const LoginPage = React.lazy(() => import('../../authentication/components/LoginPage'));
const ForgotPasswordPage = React.lazy(() => import('../../authentication/components/ForgotPasswordPage'));
const ResetPasswordPage = React.lazy(() => import('../../authentication/components/ResetPasswordPage'));
const UserProfile = React.lazy(() => import('../../authentication/components/UserProfile'));

const authenticationRoutes = [
  {
    path: routeMappings['LOGIN'],
    exact: true,
    component: withNoAuthentication(LoginPage),
    customProps: {
      pageName: 'signinSignupTitle',
    },
  },
  {
    path: routeMappings['SSO'],
    exact: true,
    component: withBasicDetails(SocialSignOnConfirm),
    customProps: {
      pageName: 'ssoTitle',
    },
  },
  {
    path: routeMappings['FORGOT_PASSWORD'],
    exact: true,
    component: withNoAuthentication(ForgotPasswordPage),
    customProps: {
      pageName: 'forgotPassword',
    },
  },
  {
    path: routeMappings['RESET_PASSWORD'],
    exact: true,
    component: ResetPasswordPage,
    customProps: {
      pageName: 'resetPassword',
    },
  },
  {
    path: routeMappings['USER_PROFILE'],
    exact: true,
    component: withBasicDetails(UserProfile),
    customProps: {
      pageName: 'userProfile',
    },
  },
];

export default authenticationRoutes;
